/**
 * Shared types for edge condition configuration.
 *
 * Condition types kept in sync with the backend enum in
 * benchling/pipelines/steps/models/pipeline_step_definition.py
 */

export enum EdgeConditionType {
  DATASETS_DO_NOT_EXIST = 'DATASETS_DO_NOT_EXIST',
  DATASETS_EXIST = 'DATASETS_EXIST',
  FILES_DO_NOT_EXIST = 'FILES_DO_NOT_EXIST',
  FILES_EXIST = 'FILES_EXIST',
}

export const CONDITION_TYPE_DISPLAY_NAMES: Record<EdgeConditionType, string> = {
  [EdgeConditionType.DATASETS_DO_NOT_EXIST]: 'Datasets do not exist',
  [EdgeConditionType.DATASETS_EXIST]: 'Datasets exist',
  [EdgeConditionType.FILES_DO_NOT_EXIST]: 'Files do not exist',
  [EdgeConditionType.FILES_EXIST]: 'Files exist',
};

export interface EdgeCondition {
  type: EdgeConditionType;
}
